export const getMessageByStatus = (status: number) => {
  switch (status) {
    case 400:
      return 'The request was invalid. Please check your input and try again.';
    case 401:
      return "You're not authorized to access this resource. Please sign in again.";
    case 403:
      return "You don't have permission to perform this action.";
    case 404:
      return 'The requested resource could not be found.';
    case 408:
      return 'The request timed out. Please check your connection and try again.';
    case 429:
      return 'Too many requests. Please wait a moment before trying again.';
    case 500:
      return 'Our servers are experiencing issues. Please try again later.';
    case 502:
      return 'Bad gateway. Our servers are temporarily unavailable.';
    case 503:
      return 'Service temporarily unavailable. Please try again in a few minutes.';
    case 504:
      return 'Gateway timeout. The server took too long to respond.';
    default:
      return status >= 500
        ? "We're experiencing server issues. Please try again later."
        : 'There was a problem with your request. Please try again.';
  }
};
